import vSelect from '@/components/form/v-select/v-select';

export default vSelect;
